import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

import AppLayout from "@/components/layout/AppLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/auth/Login";
import SignupProfessional from "@/pages/auth/SignupProfessional";
import SignupPatient from "@/pages/auth/SignupPatient";
import PendingApproval from "@/pages/auth/PendingApproval";
import ForgotPassword from "@/pages/auth/ForgotPassword";
import ResetPassword from "@/pages/auth/ResetPassword";
import TermsOfService from "@/pages/legal/TermsOfService";
import PrivacyPolicy from "@/pages/legal/PrivacyPolicy";

import Dashboard from "@/pages/Dashboard";
import Patients from "@/pages/Patients";
import PatientDetail from "@/pages/PatientDetail";
import Agenda from "@/pages/Agenda";
import SessionsPage from "@/pages/Sessions";
import { Settings } from "@/pages/Settings";
import Vinculacoes from "@/pages/professional/Vinculacoes";
import Convites from "@/pages/professional/Convites";
import ClinicManagement from "@/pages/professional/ClinicManagement";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import Financeiro from "@/pages/Financeiro";

import PatientLayout from "@/pages/patient/PatientLayout";
import { PatientHome, PatientAppointments, PatientSessions } from "@/pages/patient/PatientPages";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro/profissional" element={<SignupProfessional />} />
            <Route path="/cadastro/paciente" element={<SignupPatient />} />
            <Route path="/pending-approval" element={<PendingApproval />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/legal/termos" element={<TermsOfService />} />
            <Route path="/legal/privacidade" element={<PrivacyPolicy />} />

            {/* Professional area */}
            <Route path="/app" element={
              <ProtectedRoute role="professional"><AppLayout breadcrumbs={["Dashboard"]}><Dashboard /></AppLayout></ProtectedRoute>
            } />
            <Route path="/app/pacientes" element={
              <ProtectedRoute role="professional"><AppLayout breadcrumbs={["Pacientes"]}><Patients /></AppLayout></ProtectedRoute>
            } />
            <Route path="/app/pacientes/:id" element={
              <ProtectedRoute role="professional"><AppLayout breadcrumbs={["Pacientes","Prontuário"]}><PatientDetail /></AppLayout></ProtectedRoute>
            } />
            <Route path="/app/vinculacoes" element={
              <ProtectedRoute role="professional" clinicRole={["admin", "receptionist"]}><AppLayout breadcrumbs={["Vínculos"]}><Vinculacoes /></AppLayout></ProtectedRoute>
            } />
            <Route path="/app/convites" element={
              <ProtectedRoute role="professional" clinicRole="admin"><AppLayout breadcrumbs={["Convites"]}><Convites /></AppLayout></ProtectedRoute>
            } />
            <Route path="/app/clinica" element={
              <ProtectedRoute role="professional" clinicRole="admin"><AppLayout breadcrumbs={["Minha Clínica"]}><ClinicManagement /></AppLayout></ProtectedRoute>
            } />
            <Route path="/app/agenda" element={
              <ProtectedRoute role="professional"><AppLayout breadcrumbs={["Agenda"]}><Agenda /></AppLayout></ProtectedRoute>
            } />
            <Route path="/app/sessoes" element={
              <ProtectedRoute role="professional" clinicRole={["admin", "professional"]}><AppLayout breadcrumbs={["Sessões"]}><SessionsPage /></AppLayout></ProtectedRoute>
            } />
            <Route path="/app/configuracoes" element={
              <ProtectedRoute role="professional"><AppLayout breadcrumbs={["Configurações"]}><Settings /></AppLayout></ProtectedRoute>
            } />
            <Route path="/app/financeiro" element={
              <ProtectedRoute role="professional"><AppLayout breadcrumbs={["Financeiro"]}><Financeiro /></AppLayout></ProtectedRoute>
            } />

            {/* Admin Area */}
            <Route path="/admin" element={
              <ProtectedRoute role="superadmin"><AppLayout breadcrumbs={["Admin","Dashboard"]}><AdminDashboard /></AppLayout></ProtectedRoute>
            } />

            {/* Patient portal */}
            <Route path="/portal" element={<ProtectedRoute role="patient"><PatientLayout /></ProtectedRoute>}>
              <Route index element={<PatientHome />} />
              <Route path="agenda" element={<PatientAppointments />} />
              <Route path="sessoes" element={<PatientSessions />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Landing />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
